import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

const Portal = ({ children }) => {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
        // Find the portal-root element we created in index.html
        const portalRoot = document.getElementById('portal-root');
        return () => {
            // Cleanup on unmount if needed
        };
    }, []);

    // Use the portal only if the component is mounted on the client
    // This prevents issues with server-side rendering (though you aren't using it now)
    return mounted 
        ? createPortal(children, document.getElementById('portal-root')) 
        : null;
};

export default Portal;